import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import { getContent } from "../../utils/main";
import * as Icon from "react-bootstrap-icons";
import { Spinner } from "react-bootstrap";

export const EmailActivation = () => {
  const content = useSelector((state) => state.mainSlice.content);
  const lang = useSelector((state) => state.mainSlice.lang);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const params = useParams();

  useEffect(() => {
    const formData = new FormData();
    if (localStorage.getItem("email") !== null) {
      formData.append("email", localStorage.getItem("email"));
    }
    formData.append("token", params.token);
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/api/v1/subscribe/check/`,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((data) => {
        if (data.status === 200) {
          setError(null);
          //
        } else {
          setError(data.response.data.detail);
        }
      })
      .catch((data) => {
        setError(data.response.data.detail);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <div className="email-activation-page py-5 my-5">
      <div className="container">
        <div className="row">
          <div className="col-12">
            {loading === true ? (
              <div className="d-flex justify-content-center align-items-center">
                <Spinner style={{ color: "#198754" }} />
              </div>
            ) : error === null ? (
              <div className="activation-wrapper text-center">
                <Icon.CheckCircle
                  style={{
                    color: "#198754",
                    fontSize: 120,
                    marginBottom: "20px",
                  }}
                />
                <br />
                {getContent(content, "Email is activated successfully!", lang)}
              </div>
            ) : (
              <div className="activation-wrapper text-center">
                <Icon.XCircle
                  style={{
                    color: "#bd4147",
                    fontSize: 120,
                    marginBottom: "20px",
                  }}
                />
                <br />
                {error[lang]}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
